import * as Popover from "@radix-ui/react-popover";
import { useEffect, useMemo, useState } from "react";
import { Member } from "../../Models/Member/Member.Current";
import MembersModel from "../../Models/Member/Members.Model";

export function MembersOnlineSection() {
  const { availableMembers, membersMap } = MembersModel.useState((s) => s);

  const [isOpen, setIsOpen] = useState(false);
  const membersOnline: number[] | undefined = useMemo(() => {
    if (!availableMembers) { return undefined };
    return Object.keys(availableMembers).map(Number).filter((memberId) => memberId !== Member.id);
  }, [availableMembers]);

  useEffect(() => {
    MembersModel.getMembersAvailability();
    const interval = setInterval(() => {
      MembersModel.getMembersAvailability();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const areMembersOnline = membersOnline && Object.keys(membersOnline).length > 0;

  const handleToggleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  if (!membersOnline) {
    return null;
  }

  return (
    <Popover.Root
      open={isOpen}
      onOpenChange={setIsOpen}
      modal={false}
    >
      {areMembersOnline ? (
        <Popover.Trigger asChild onMouseEnter={handleToggleOpen} onMouseLeave={handleToggleOpen}>
          <div className="h-fit flex items-center gap-2 py-2">
            <span className="text-sm">{membersOnline.length} other member{membersOnline.length === 1 ? "" : "s"} online</span>
            <div className="flex -space-x-4">
              {membersOnline.map((memberId) => (
                <img key={memberId} src={membersMap && membersMap[memberId]?.agentAvatarURL || "/default-avatar.png"} alt="Member Avatar" className="size-7 rounded-full" />
              ))}
            </div>
          </div>
        </Popover.Trigger>
      ) : (
        <div className="p-4 text-center text-gray-500">
          No agents online
        </div>
      )}

      <Popover.Content
        side="bottom"
        align="start"
        className="bg-grey-800 shadow-lg rounded-lg w-44 outline-none"
        onMouseEnter={handleToggleOpen}
        onMouseLeave={handleToggleOpen}
      >
        <ul className="bg-inherit rounded-lg divide-y divide-grey-700 text-white">
          {membersOnline.map((memberId) => (
            <li key={memberId} className="flex p-3 items-center gap-3">
              <img
                src={membersMap && membersMap[memberId]?.agentAvatarURL || "/default-avatar.png"}
                alt={`${membersMap && membersMap[memberId]?.agentName} avatar`}
                className="size-5 rounded-full"
              />
              <span className="text-sm">{membersMap && membersMap[memberId]?.agentName || "Unknown Member"}</span>
            </li>
          ))}
        </ul>
      </Popover.Content>
    </Popover.Root>
  );
}


